import aboutSection from './about-section';
import introSection from './intro-section';
import tabEightSection from './tab-eight-section';
import tabFiveSection from './tab-five-section';
import tabFourSection from './tab-four-section';
import tabNineSection from './tab-nine-section';
import tabOneSection from './tab-one-section';
import tabSevenSection from './tab-seven-section';
import tabSixSection from './tab-six-section';
import tabThreeSection from './tab-three-section';
import tabTwoSection from './tab-two-section';
import tabsMenuSection from './tabs-menu-section';

const sections = {
  introSection,
  aboutSection,
  tabsMenuSection,
  tabOneSection,
  tabTwoSection,
  tabThreeSection,
  tabFourSection,
  tabFiveSection,
  tabSixSection,
  tabSevenSection,
  tabEightSection,
  tabNineSection,
};

export { sections };
